import {
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ProcessesCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  form: {
    button: {
      assignContactOwnerAsOwner: string;
    };
    calendarEntryQuery: {
      autoName: {
        entryWithoutRange: string;
        entryWithRange: string;
        rangeWithoutEntry: string;
      };
    };
    customer: {
      button: {
        chooseContact: string;
        chooseCustomer: string;
      };
      contactOwnerId: string;
      contactSectionTitle: string;
      customerName: string;
      customerSectionTitle: string;
      firstName: string;
      flag: string;
      flagOptions: FlagOptionsTranslation;
      lastName: string;
      name: string;
      status: string;
      statusOptions: CustomerStatusOptionsTranslation;
      type: string;
      typeOptions: CustomerTypeOptionsTranslation;
    };
    customerRequiredForContact: string;
    description: string;
    name: string;
    nameHint: string;
    namePlaceholder: string;
    noteText: string;
    offer: {
      chooseDefinitionFirst: string;
      definition: string;
      definitionPlaceholder: string;
      definitionsError: string;
      hint: string;
      item: string;
      itemPlaceholder: string;
      loading: string;
      noBooking: {
        calendarsDisabled: string;
        inactiveEntry: string;
      };
      noDefinitions: string;
      singleItem: string;
      title: string;
    };
    processOwnerId: string;
  };
  toast: {
    created: string;
    open: string;
    openOffer: string;
  };
  title: string;
};

export const processesCreateTranslation: ProcessesCreateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  form: {
    button: {
      assignContactOwnerAsOwner: 'Przypisz opiekuna jako właściciela',
    },
    calendarEntryQuery: {
      autoName: {
        entryWithoutRange: '{{entry}} — termin do ustalenia',
        entryWithRange: '{{entry}} — {{range}}',
        rangeWithoutEntry: 'Zapytanie o zasób — {{range}}',
      },
    },
    customer: {
      button: {
        chooseContact: 'Przypisz kontakt wraz z jego klientem',
        chooseCustomer: 'Przypisz tylko klienta',
      },
      contactOwnerId: 'Opiekun',
      contactSectionTitle: 'Kontakt',
      customerName: 'Nazwa klienta',
      customerSectionTitle: 'Klient',
      firstName: 'Imię',
      flag: 'Flaga',
      flagOptions: flagOptionsTranslation,
      lastName: 'Nazwisko',
      name: 'Nazwa',
      status: 'Status',
      statusOptions: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOptions: customerTypeOptionsTranslation,
    },
    customerRequiredForContact: 'Kontakt musi być powiązany z klientem.',
    description: 'Opis',
    name: 'Nazwa',
    nameHint: 'Wpisz krótką nazwę opisującą proces.',
    namePlaceholder: 'np. Sala A — 2026-03-12',
    noteText: 'Notatka',
    offer: {
      chooseDefinitionFirst: 'Najpierw wybierz definicję oferty',
      definition: 'Definicja oferty',
      definitionPlaceholder: 'Wybierz definicję oferty',
      definitionsError:
        'Nie udało się pobrać definicji ofert. Zapis utworzy sam proces, bez oferty.',
      hint: 'Zapis utworzy ofertę z terminem zapytania i rezerwacją wstępną elementu słownika w wybranej pozycji.',
      item: 'Pozycja komponentu',
      itemPlaceholder: 'Wybierz pozycję komponentu',
      loading: 'Ładowanie definicji ofert',
      noBooking: {
        calendarsDisabled:
          'Rezerwacja wstępna nie powstanie: typ słownika nie ma włączonych kalendarzy. Zapis utworzy sam proces, bez oferty.',
        inactiveEntry:
          'Rezerwacja wstępna nie powstanie: element słownika jest nieaktywny. Zapis utworzy sam proces, bez oferty.',
      },
      noDefinitions:
        'Żadna aktywna definicja oferty nie ma komponentu tego typu słownika z pozycją słownikową. Zapis utworzy sam proces, bez oferty.',
      singleItem: 'Komponent ma jedną pozycję słownikową, więc element słownika trafi do niej.',
      title: 'Oferta z rezerwacją wstępną',
    },
    processOwnerId: 'Właściciel procesu',
  },
  toast: {
    created: 'Proces został utworzony.',
    open: 'Otwórz proces',
    openOffer: 'Otwórz ofertę',
  },
  title: 'Tworzenie nowego procesu',
};
